import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BessIqIndex from './BessIqIndex';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BessIqIndex/>
);
